import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const SentimentDissatisfiedIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0  40 40" style={{ color, fontSize, ...style }} {...rest}>
      <circle cx="19.6922" cy="19.6883" r="18.5809" stroke="#FF462D" strokeWidth="2" />
      <path
        d="M12.7258 14.0049L15.5191 16.1333C15.6284 16.2165 15.6231 16.3826 15.5089 16.4588L12.7258 18.314"
        stroke="#FF462D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27.9976 17.8502L24.7486 16.5173C24.6215 16.4651 24.5836 16.3034 24.6742 16.2002L26.8823 13.6879"
        stroke="#FF462D"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13.5342 28.543C15.5346 25.9861 20.7984 22.4064 25.8506 28.543"
        stroke="#FF462D"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  )
}
export default SentimentDissatisfiedIcon
